import { CompactPlan, Mtds, PlansToggleValue } from 'prove-common'

type PlansScreenToggleGroupProps = {
  toggleValue: PlansToggleValue
  setToggleValue: (value: PlansToggleValue) => void
  plans: CompactPlan[] | undefined
  className?: string
}

const count = (plans: CompactPlan[], status: string) =>
  plans.filter((plan) => plan.status === status).length

export const PlansScreenToggleGroup = ({
  toggleValue,
  setToggleValue,
  plans = [],
  className
}: PlansScreenToggleGroupProps) => {
  const items: { value: PlansToggleValue; label: string }[] = [
    { value: 'active', label: `Aktive (${count(plans, 'active')})` },
    { value: 'draft', label: `Utkast (${count(plans, 'draft')})` },
    {
      value: 'deactivated',
      label: `Deaktiverte (${count(plans, 'deactivated')})`
    },
    { value: 'all', label: `Alle (${plans.length})` }
  ]

  return (
    <Mtds.Field
      as='select'
      aria-label='Filtrer planer'
      value={toggleValue}
      onChange={({ target }) =>
        setToggleValue(target.value as PlansToggleValue)
      }
      options={items}
      className={className}
    />
  )
}
